<template>
	<v-form>
      	<v-container fluid v-if="this.hotels.length">
        	<v-row >
          		<v-col>
					<p class="display-1">
						Прогноз на месяц
					</p>
				</v-col>
        	</v-row>
        	<v-row >
          		<v-col class="pb-0" cols="12" sm="6" >
					<a-hotel-select v-model="hotelCode"
							  	 :hotels="hotels"
							  	 @change="changeHotel"
								 solo>
					</a-hotel-select>
				</v-col>
        	</v-row>
        	<v-row >
          		<v-col class="pt-0" cols="12" md="6" >
					<v-subheader>Месяц</v-subheader>
					<v-date-picker 	v-model="month"
									type="month"
									:landscape="$vuetify.breakpoint.smAndUp"
									:reactive="true"
									locale="ru-ru"
									required
									:show-current="false"
									:max="maxMonth"
									:min="minMonth"
									full-width>
					</v-date-picker>
				</v-col>
	        </v-row>
        	<v-row >
				<v-col class="py-0" >

					<v-radio-group v-model="lan" :row="$vuetify.breakpoint.smAndUp">
						<template v-slot:label>
		        			<div style="width: 100px">Язык</div>
		      			</template>
						<v-radio label="Русский" value="ru"></v-radio>
						<v-radio label="Английский" value="en"></v-radio>
					</v-radio-group>
					<v-checkbox v-model="unit"
								:disabled="type=='2'"
								label="В тысячах">
					</v-checkbox>
				</v-col>
        	</v-row>
			<v-row>
				<v-col class="pl-1" cols="12" >
			        <v-btn class="ma-2" color="primary" @click="combine('pdf')">Сформировать PDF</v-btn>
			        <v-btn class="ma-2" color="primary" @click="combine('xls')">Сформировать XLS</v-btn>
				</v-col>
			</v-row>
    	</v-container>
		<v-container fluid v-else>
			<v-row >
				<v-col>
					<p class="subtitle-1">
						Нет доступных отчетов
					</p>
				</v-col>
			</v-row>
		</v-container>
	</v-form>
</template>

<script>
	import aHotelSelect from '../../base/AHotelSelect.vue'
	import {api} from '../../../lib/api'
	import {display} from '../../../lib/display'

	export default {
		components: {
			aHotelSelect
		},
		data: () => ({
			hotelCode: '',
			hotels: null,
			month: "",
			type: '1',
			unit: true,
			showNullLines: false,
			showInitialData: false,
			lan: 'ru'
		}),
		computed: {
			selected() {
				return this.hotels.map(hotel => (hotel.code || null)).indexOf(this.hotelCode)
			},
			maxMonth() {
				if (this.showInitialData) return undefined
				else if (this.selected == -1) return undefined
				else return this.hotels[this.selected].maxMonth
			},
			minMonth() {
				if (this.showInitialData) return undefined
				else if (this.selected == -1) return undefined
				else return this.hotels[this.selected].minMonth
			},
		},
		created() {
			this.lan = this.$store.getters.prefLan

			if (this.$store.getters.userHo) {
				this.hotels = this.$store.getters.allHotels
			}
			else {
				this.hotels = this.$store.getters.userHotels
			}

			api.post('pl/get_available_fcst_months', { hotels: this.hotels })
			.then(response => {
				this.hotels = response.data.hotels

				if (this.hotels.length) {
					let selHotelCode = this.$store.getters.selectedHotelCode
					if (selHotelCode && this.hotels.find(el => el.code == selHotelCode)) {
						this.hotelCode = selHotelCode
					}
					else {
						this.hotelCode = this.hotels[0].code
						this.$store.dispatch('setSelectedHotelCode', this.hotelCode)
					}

					this.changeHotel()
				}

			}, error => {})
		},
		mounted() {
			// this.dept = this.$refs.deptSelect.filteredDepts[0].code
		},
		methods: {
			changeHotel() {
				this.month = this.maxMonth
			},
			combine(format) {
				if (!this.month) return

				display.open({
					reportCode: 'pl_month_fcst',
					userId: this.$store.getters.userId,
					hotelCode: this.hotelCode,
					dept: 10,
					month: this.month,
					format: format,
					type: this.type,
					unit: this.unit ? 1000 : 1,
					showNullLines: this.showNullLines,
					showInitialData: this.showInitialData,
					lan: this.lan
				})
			}
		}
	}
</script>
